import { c as _c } from "react/compiler-runtime";
import { Heading, Image, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import type { MenuCardProps } from './types';
export const trackingData = (data: object) => Object.assign(data, {
  ...layoutEvents.headerMenuNavClick
});
export function MenuCard(t0) {
  const $ = _c(18);
  const {
    card,
    category,
    onClick
  } = t0;
  const href = card.link?.webUrl ?? "#";
  const imgSrc = card.image.remoteMobileImageUrl ?? card.image.remoteDesktopImageUrl ?? "";
  let t1;
  if ($[0] !== card.header || $[1] !== category || $[2] !== href || $[3] !== onClick) {
    t1 = () => {
      onClick?.();
      dataLayerPush(trackingData({
        selection: `${category} | ${card.header}`,
        link_url: getBaseUrlJoined(href)
      }));
    };
    $[0] = card.header;
    $[1] = category;
    $[2] = href;
    $[3] = onClick;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== card.image.webAltText || $[6] !== imgSrc) {
    t2 = imgSrc && <Image src={imgSrc} alt={card.image.webAltText} />;
    $[5] = card.image.webAltText;
    $[6] = imgSrc;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== card.header) {
    t3 = <Heading tagName="h3" size="body-bold">{card.header}</Heading>;
    $[8] = card.header;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== card.description) {
    t4 = card.description && <TextPassage data-testid="sparky-card-out-of-stock" size="sm"><p>{card.description}</p></TextPassage>;
    $[10] = card.description;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== href || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <li className="menu-card"><Link onClick={t1} href={href} prefetch={false}>{t2}{t3}{t4}</Link></li>;
    $[12] = href;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}